import { render, staticRenderFns } from "./SliceHowItWorks.vue?vue&type=template&id=84755830&lang=pug&"
import script from "./SliceHowItWorks.vue?vue&type=script&lang=js&"
export * from "./SliceHowItWorks.vue?vue&type=script&lang=js&"
import style0 from "./SliceHowItWorks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports